<template>
    <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">
    <!-- <img class="background-img col-12 cover h100 flying-body" src="../assets/cls_sideview.png"> -->
  <div class="lightbox">
    <div class="register-window mx-auto pt3 pr4 pl4 pb3 border-box box-shadow-big bg-color-darkgray col-12 lightbox-box rounded-border">
      <div class="flex align-middle mb4">
        <div>
          <h2 class="h1 color-primary regular">{{$t('addinfo_headline_h2')}}</h2>
          <h3 class="p color-primary" style="margin-top: -.35rem">{{$t('addinfo_headline_h3')}}</h3>
        </div>
      </div>
        <div>
          <p class="col-6 mt3">{{$t('addinfo_email')}}</p>
          <p class="h4 mb3" v-bind:class="{ error: not_filled_email}">{{userdata.email}}</p>
          <div class="col-12">
              <div class="col-6" v-if="missingfields.includes('salutations_id')">
                <p class="col-6">{{$t('addinfo_salutation')}}*</p>
                <div class="relative mb2 user-select-wrapper col-12">
                  <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                  <select id="Anrede" name="Anrede" v-model="onboardingData.salutations_id" v-bind:class="{ error: not_filled_anrede}" class="user-input">
                    <option value="0" disabled>{{$t('addinfo_salutation')}}</option>
                    <option value="1">{{$t('addinfo_salutation_mr')}}</option>
                    <option value="2">{{$t('addinfo_salutation_mrs')}}</option>
                  </select>   
                </div>
              </div>
              <div class="col-6" v-if="missingfields.includes('firstname')">
                <p class="col-6" v-bind:class="{ error: not_filled_vorname}">{{$t('addinfo_firstname')}}*</p>
                <input class="user-input col-12 mb2" :placeholder="$t('addinfo_firstname')" v-model="onboardingData.firstname">
              </div>
              <div class="col-6" v-if="missingfields.includes('name')">
                <p class="col-6" v-bind:class="{ error: not_filled_nachname}">{{$t('addinfo_name')}}*</p>
                <input class="user-input col-12 mb2" :placeholder="$t('addinfo_name')" v-model="onboardingData.name">
              </div>
              <div class="col-6" v-if="missingfields.includes('password')">
                <p class="col-6" v-bind:class="{ error: not_filled_password}">{{$t('addinfo_password')}}*</p>
                <input type="password" class="user-input col-12 mb2" placeholder="********" v-model="onboardingData.password">
              </div>
              <div class="col-6" v-if="missingfields.includes('comapany')">
                <p class="col-6"  v-bind:class="{ error: not_filled_firma}">{{$t('addinfo_company')}}*</p>
                <input class="user-input col-12 mb2" :placeholder="$t('addinfo_company')"  v-model="onboardingData.company">
              </div>
              <div class="col-6" v-if="missingfields.includes('tel')">
                <p class="col-6" v-bind:class="{ error: not_filled_phone}">{{$t('addinfo_tel')}}*</p>
                <input class="user-input col-12 mb2" placeholder="+49 123 456 789" v-model="onboardingData.tel">
              </div>
              <div class="col-6" v-if="missingfields.includes('position')">
                <p class="col-6">{{$t('addinfo_position')}}</p>
                <input class="user-input col-12 mb2" :placeholder="$t('addinfo_position')"  v-model="onboardingData.position">
              </div>
              <div class="col-6" v-if="missingfields.includes('city')">
                <p class="" v-bind:class="{ error: not_filled_city}">{{$t('addinfo_city')}}</p>
                <input class="user-input col-12 mb2" :placeholder="$t('addinfo_city')" v-model="onboardingData.city">
              </div>
              <div class="col-6" v-if="missingfields.includes('countries_id')">
                <p v-bind:class="{ error: not_filled_country}">{{$t('addinfo_country')}}</p>
                <div class="relative user-select-wrapper mb2">
                  <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                  <select class="user-input col-12 mb1" id="CountrySelect" name="CountrySelect" v-model="onboardingData.countries_id">
                    <option value="0" disabled>{{$t('addinfo_country')}}</option>
                    <option v-for="country in countries_list.data" :key="country.id" :value="country.id">
                      {{ country.countryname }}
                    </option>
                  </select> 
                </div>
              </div>
              <div class="col-6" v-if="missingfields.includes('password')">
                <p class="col-6" v-bind:class="{ error: not_filled_password_repeat}">{{$t('addinfo_password_repeat')}}*</p>
                <input type="password" class="user-input col-12 mb2" placeholder="********" v-model="onboardingData.password_repeat">
              </div>             
              <div class="flex align-middle mt3" v-if="missingfields.includes('dsgvo')">
                <input id="dsgvo-register" class="checkbox-input mr2" type="checkbox" v-model="checkdsgvo">
                <label for="dsgvo-register" class="pointer" v-bind:class="{ error: not_filled_checkdsgvo}">{{$t('addinfo_check_dsgvo_text')}}*</label>
              </div>
          </div>

          <div class="col-12 error-msg">
            <label v-bind:class="{ error: !allIsValidated, hidden: allIsValidated}">{{$t('addinfo_all_fields_text')}}</label>
          </div>
          <div class="col-12 error-msg">
            <label class="error" id="apiError">{{apiError}}</label>
          </div>

          <a class="btn btn-primary mt3" @click="validateReg()">{{$t('addinfo_complete_Data_btn')}}</a>
          <router-link class="btn btn-primary mt3 ml4" :to="'/' + this.$i18n.locale" >{{$t('addinfo_back_login_btn')}}</router-link>
        </div>

      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import { EventBus } from "@/event-bus";

export default {
    name: "addInfo",
  data() {
    return {
    session: {},
    userdata: {},

      loginStatus: false,
      missingfields: [],
      onboardingData: {
        salutations_id: 0,
        firstname: '',
        name: '',
        company: '',
        position: '',
        email: '',
        city: '',
        tel: '',
        countries_id: 0,
        password: '',
        password_repeat: '',
        channel: 'quick-and-light-app-de',
        password_set_by_user: 1,
      },
      checkdsgvo: false,
      debug: false,
      not_filled_anrede: false,
      not_filled_vorname: false,
      not_filled_nachname: false,
      not_filled_firma: false,
      not_filled_email: false,
      not_filled_phone: false,
      not_filled_city: false,
      not_filled_country: false,
      not_filled_checkdsgvo: false,
      not_filled_password: false,
      not_filled_password_repeat: false,
      not_same_password: false,
      countries_list: [],
      allIsValidated: true,
      apiError: '',
      apiSuccess: ''
    };
  },
  created() {
    console.log('addInfo.vue: Create call');

    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));
      
    EventBus.$on('missingFieldsLoginEvent2', (payload) => {
        console.log('addInfo.vue: missingFieldsLoginEvent2 triggered')
        
        this.missingfields = payload.missingfields;
    });

    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      //console.log('CQLHeaderbar recieved loginSuccessfulSubComponents');
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
      console.log('addInfo.vue: sending Event: missingFieldsLoginRecieveEvent')
      EventBus.$emit('missingFieldsLoginRecieveEvent');

    });

    // EventBus.$on('loginCheckQaL', () => {
    //   console.log('addInfo.vue recieved Event: "loginCheckQaL"!');
    //   if(!this.loginStatus) {
    //     console.log('Can not perfom login-Validation!');
    //     EventBus.$emit('loginNotCorrect',{});
    //   }
    // });

    EventBus.$on('loginNotCorrect', () => {
      this.$router.push({ path:'/' + this.$il8n.locale + '/logout-session'});
    });

    EventBus.$emit('loginCheckQaL', {});

    
  
  }, 
  mounted(){
    EventBus.$on('missingFieldsLoginEvent', (payload) => {
        console.log('addInfo.vue: missingFieldsLoginEvent triggered')
        console.log(payload);
    });
  

  },
  methods: {

    log: function (obj) {
      if(this.debug) {
        console.log(obj);
      }
    },
    validateReg(){

      console.log('Start validate reg addinfo')

      this.allIsValidated = true;

      if(this.onboardingData.salutations_id == '' && this.missingfields.includes('salutations_id')) {
        this.not_filled_anrede = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.prename == '' && this.missingfields.includes('prename')) {
        this.not_filled_vorname = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.name == '' && this.missingfields.includes('name')) {
        this.not_filled_nachname = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.company == '' && this.missingfields.includes('company')) {
        this.not_filled_firma = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.tel == '' && this.missingfields.includes('tel')) {
        this.not_filled_phone = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.password == '' && this.missingfields.includes('password')) {
        this.not_filled_password = true;
        this.allIsValidated = false;
      }
      if(this.onboardingData.password_repeat == '' && this.missingfields.includes('password')) {
        this.not_filled_password_repeat = true;
        this.allIsValidated = false;
      } else {
        if((this.onboardingData.password_repeat != this.onboardingData.password) && this.missingfields.includes('password')) {
          this.not_same_password = true;
          this.allIsValidated = false;
        }
      }
      if(this.checkdsgvo == false && this.missingfields.includes('dsgvo')) {
        this.not_filled_checkdsgvo = true;
        this.allIsValidated = false;
      }

      
      let createURL = process.env.VUE_APP_APIENDPOINT +  '/quickandlightapp/update-user-data'
      let currentObj = this;
      let data = {};

      data.customerData = this.onboardingData;
      
      let merged = {...data, ...this.session};

      if(this.allIsValidated) {
        axios.post(createURL, merged)
        .then(function (response) {
          console.log(response.data);
          if(response.data.infomessage == 'FIELDSHAVEBEENUPDATED'){
            console.log('fields have been updated');
            if(response.data.forwardmessage == 'LOGIN_OKAY'){
              currentObj.$router.push({ path:'/' + currentObj.$i18n.locale + '/projects'});
            }
            if(response.data.forwardmessage == "LOGIN_OKAY_BUT_CONTRACT_MISSING") {
              console.log('fields have been updated');
              currentObj.$router.push({ path:'/' + currentObj.$i18n.locale + '/contractsign'});
            } 
            }else{
              console.log('fields have not been updated');
            }
        })
        .catch(function (error) {
          console.log('catch Function of AJAX-Called... error()');
          console.log(error);
          currentObj.apiResponse = error;

        });
      }
    },

  },

};
</script>
<style>
</style>
